export default __webpack_public_path__ + "static/media/12_sofort.f19bb06b.svg";